// =============================================================================
// Permisos del módulo de interacciones (issue #384)
// =============================================================================
// Espejo de lo que exige el backend (src/routes/index.ts):
//  - Escritura (crear, editar, archivar, desarchivar, notas, adjuntos):
//    Roles.INTERNOS_ESCRITURA. MESA_ENTRADAS y AUDITOR quedan en solo lectura.
//  - Eliminar: ADMINISTRADOR y SUPERVISOR, más AUTORIDAD_FIRMANTE, que hereda
//    SUPERVISOR (ROLES_HEREDADOS en src/middleware/auth.ts).
// Lista de roles PERMITIDOS a propósito: un rol nuevo no queda habilitado por
// accidente. Si cambian los roles en el backend, hay que actualizar esto.
// =============================================================================

export const ROLES_ESCRITURA_INTERACCIONES = ['ADMINISTRADOR', 'SUPERVISOR', 'AUTORIDAD_FIRMANTE', 'ANALISTA'];
export const ROLES_ELIMINAR_INTERACCIONES = ['ADMINISTRADOR', 'SUPERVISOR', 'AUTORIDAD_FIRMANTE'];

export const puedeEscribirInteracciones = (rol?: string | null): boolean =>
  !!rol && ROLES_ESCRITURA_INTERACCIONES.includes(rol);

export const puedeEliminarInteracciones = (rol?: string | null): boolean =>
  !!rol && ROLES_ELIMINAR_INTERACCIONES.includes(rol);
